import React, { useState } from 'react';
import { apiFetch } from './api';

const BrokerRow = ({ broker, busy, onUpdate }) => {
  const [name, setName] = useState(broker.name);
  return (
    <div className="broker-profile-row">
      <input value={name} maxLength="60" onChange={(event) => setName(event.target.value)} />
      <button type="button" disabled={busy || !name.trim() || name.trim() === broker.name} onClick={() => onUpdate(broker.id, { name: name.trim() })}>Rename</button>
      <button type="button" className={broker.is_active ? 'broker-disable' : ''} disabled={busy} onClick={() => onUpdate(broker.id, { isActive: !broker.is_active })}>
        {broker.is_active ? 'Deactivate' : 'Activate'}
      </button>
    </div>
  );
};

const BrokerProfile = ({ brokers, busy, error, isAdmin, canTrade, riskPerTrade, onUpdated, onAdd, onUpdate, onManageUsers, onClose }) => {
  const [name, setName] = useState('');
  const [risk, setRisk] = useState(String(riskPerTrade ?? 70000));
  const [riskBusy, setRiskBusy] = useState(false);
  const [riskMessage, setRiskMessage] = useState('');
  const [riskError, setRiskError] = useState('');

  const add = async (event) => {
    event.preventDefault();
    if (await onAdd(name.trim())) setName('');
  };

  const saveRisk = async (event) => {
    event.preventDefault();
    setRiskBusy(true);
    setRiskMessage('');
    setRiskError('');
    try {
      const response = await apiFetch('/api/profile', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ riskPerTrade: risk }),
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error || 'Unable to update risk per trade');
      onUpdated(body.user);
      setRisk(String(body.user.riskPerTrade));
      setRiskMessage('Risk per trade saved');
    } catch (requestError) {
      setRiskError(requestError.message);
    } finally {
      setRiskBusy(false);
    }
  };

  return (
    <div className="admin-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="broker-profile-dialog" role="dialog" aria-modal="true" aria-label="Profile and broker accounts">
        <header><div><strong>Profile</strong><span>{canTrade ? 'Broker accounts used for your trade journal' : 'Trade logging is disabled for this account'}</span></div><button type="button" onClick={onClose}>×</button></header>
        <form className="broker-risk-form" onSubmit={saveRisk}>
          <label className="broker-risk-field">
            <span>Risk per trade (₹)</span>
            <input type="text" inputMode="decimal" pattern="[0-9.]*" value={risk} onChange={(event) => setRisk(event.target.value.replace(/[^0-9.]/g, ''))} />
          </label>
          <button type="button" onClick={saveRisk} disabled={riskBusy || !(Number(risk) > 0)}>{riskBusy ? 'Saving…' : 'Save'}</button>
        </form>
        <p className="broker-risk-note">Suggested quantity = risk per trade ÷ (entry price − stop loss), rounded down.</p>
        {riskMessage && <div className="auth-message">{riskMessage}</div>}
        {riskError && <div className="auth-error">{riskError}</div>}
        {canTrade && <>
          <div className="broker-profile-list">
            {brokers.map((broker) => <BrokerRow key={broker.id} broker={broker} busy={busy} onUpdate={onUpdate} />)}
          </div>
          <form className="broker-add-form" onSubmit={add}>
            <input placeholder="New broker or account name" value={name} maxLength="60" onChange={(event) => setName(event.target.value)} />
            <button type="submit" disabled={busy || !name.trim()}>Add broker</button>
          </form>
        </>}
        {error && <div className="auth-error">{error}</div>}
        {isAdmin && <button type="button" className="manage-users-button" onClick={() => { onClose(); onManageUsers(); }}>Manage application users</button>}
      </section>
    </div>
  );
};

export default BrokerProfile;

